import React from 'react';
import placeholder from '../../assets/images/mealDetailPlaceholderDesktop.png';

const MealDetailLoadingDesktop = () => {
  // console.log(`MealDetailLoadingDesktop`);
  return (
    <div style={{ margin: 'auto', overflow: 'hidden' }}>
      <img src={placeholder} alt="Loading" />
    </div>
  );
};

export default MealDetailLoadingDesktop;
